export function initMenu() {
  const body = document.body;
  const menuToggle = document.querySelectorAll("[data-menu-toggle]");
  let touchStartY = 0;
  let touchEndY = 0;
  const minSwipeDistance = 50; // Minimum distance for swipe detection

  if (menuToggle) {
    menuToggle.forEach(item => {
      item.addEventListener("click", function() {
        body.classList.toggle("menu-is-open");
      });
    });
  }

  // Touch events for swipe detection
  document.addEventListener(
    "touchstart",
    e => {
      if (!body.classList.contains("menu-is-open")) return;
      touchStartY = e.changedTouches[0].screenY;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchend",
    e => {
      if (!body.classList.contains("menu-is-open")) return;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    },
    { passive: true }
  );

  function handleSwipe() {
    const swipeDistance = touchEndY - touchStartY;

    // Check if swipe up distance is greater than minimum (negative value)
    if (swipeDistance < -minSwipeDistance) {
      body.classList.remove("menu-is-open");
    }
  }
}
